<template>
  <div>
    <header class="header">
      <div class="px-4 pc-block header-content">
        <router-link :to="{ name: 'home' }">
          <p class="self-center">{{ $t("knowhowPage.backToNola") }}</p>
        </router-link>
        <a class="header-content-about" target="_blank" href="https://note.com/nolanovel/n/n85255a9abf6f">
          <img class="self-center" src="@/assets/img/knowhow/info-icon.png" />
          <p class="self-center">{{ $t("knowhowPage.aboutLink") }}</p>
        </a>
      </div>

      <img class="subheader sp-block" src="@/assets/img/knowhow/subheader-sp.jpg" />
    </header>

    <div class="content">
      <img class="subheader pc-block" src="@/assets/img/knowhow/subheader-pc.jpg" />

      <!-- 創作の学び舎へようこそ -->
      <div class="welcome">
        <div class="pt-10 text-center">
          <svg class="hat-icon" xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80">
            <g transform="translate(-920 -413)">
              <rect width="80" height="80" rx="40" transform="translate(920 413)" fill="#bac34d" />
              <g transform="translate(939.24 366.969)">
                <path
                  d="M41.021,79.9,22.647,71.444a4.516,4.516,0,0,0-3.773,0L.5,79.9a.86.86,0,0,0,0,1.561l18.374,8.458a4.51,4.51,0,0,0,3.774,0l14.5-6.675v6.721a1.152,1.152,0,0,0-.2,2.251l-.981,6.471h4.515l-.98-6.471a1.152,1.152,0,0,0-.2-2.251V82.251l1.712-.788a.86.86,0,0,0,0-1.561Z"
                  transform="translate(0 0)"
                  fill="#fff"
                />
                <path
                  d="M124.406,293.423a6.241,6.241,0,0,1-2.626-.576l-8.987-4.137v8.242c0,1.809,5.468,4.105,11.613,4.105s11.614-2.3,11.614-4.105V288.71l-8.988,4.137A6.237,6.237,0,0,1,124.406,293.423Z"
                  transform="translate(-103.646 -200.026)"
                  fill="#fff"
                />
              </g>
            </g>
          </svg>

          <p class="text-xl">{{ $t("knowhowPage.welcomeTitle") }}</p>

          <p class="welcome-body pt-6 text-left">
            {{ $t("knowhowPage.welcomeBody1") }}<br />
            {{ $t("knowhowPage.welcomeBody2") }}<br />
            {{ $t("knowhowPage.welcomeBody3") }}
          </p>

          <p class="pt-6 text-right">{{ $t("knowhowPage.welcomeSignature") }}</p>
        </div>
      </div>

      <div v-if="isNotFound" class="notfound-view">
        <div class="self-center">
          <div>
            <p>{{ $t("knowhowPage.notFoundMessage1") }}</p>
            <p>{{ $t("knowhowPage.notFoundMessage2") }}</p>
          </div>
        </div>
      </div>
      <div class="max-w-lg" v-else>
        <div class="knowhow-grid">
          <template v-for="content in contents">
            <!-- チャプター -->
            <div :key="content.title" v-if="content.type[0] === 'chapter'" class="outer-chapter">
              <div class="content-chapter">
                <div class="hat-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="41.521" height="30" viewBox="0 0 41.521 30">
                    <g transform="translate(0 -71.031)">
                      <path
                        d="M41.021,79.9,22.647,71.444a4.516,4.516,0,0,0-3.773,0L.5,79.9a.86.86,0,0,0,0,1.561l18.374,8.458a4.51,4.51,0,0,0,3.774,0l14.5-6.675v6.721a1.152,1.152,0,0,0-.2,2.251l-.981,6.471h4.515l-.98-6.471a1.152,1.152,0,0,0-.2-2.251V82.251l1.712-.788a.86.86,0,0,0,0-1.561Z"
                        transform="translate(0 0)"
                        fill="#dcb03c"
                      />
                      <path
                        d="M124.406,293.423a6.241,6.241,0,0,1-2.626-.576l-8.987-4.137v8.242c0,1.809,5.468,4.105,11.613,4.105s11.614-2.3,11.614-4.105V288.71l-8.988,4.137A6.237,6.237,0,0,1,124.406,293.423Z"
                        transform="translate(-103.646 -200.026)"
                        fill="#dcb03c"
                      />
                    </g>
                  </svg>
                </div>
                <p>{{ content.title }}</p>
              </div>
              <p v-html="toBr(content.subtitle)" />
            </div>

            <!-- コンテンツ -->
            <div v-else :key="content.title" class="knowhow-content" @click="toDetail(content.id)">
              <img :src="optimizedImage(content.cover.url)" loading="lazy" />
              <div>
                <p class="knowhow-content-title">{{ content.title }}</p>
                <p v-if="content.subTitle" class="knowhow-content-subtitle">
                  {{ content.subTitle }}
                </p>
                <div class="tag" v-html="displayedTagHtml(content.tag)" />
                <div class="read-button">
                  <div>{{ $t("knowhowPage.readButton") }}</div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>

      <div v-if="!isNotFound">
        <!-- 創作の学び舎はこちら -->
        <div class="pt-16 pb-10 text-center">
          <p class="appeal-text text-center font-semibold">
            {{ $t("knowhowPage.storeAppeal1") }}<br />{{ $t("knowhowPage.storeAppeal2") }}
          </p>
          <div class="appeal-button">
            <button @click="toStore">
              <span>{{ $t("knowhowPage.storeButton") }}</span>
              <img class="appeal-button-logo self-center" src="@/assets/img/knowhow/filmart-logo.png" />
            </button>
          </div>
        </div>

        <!-- Nola会員限定クーポン -->
        <div v-if="coupon" class="mt-10 coupon">
          <div class="coupon-left self-center">
            <div>
              <p class="coupon-left-title text-xl">{{ $t("knowhowPage.couponSectionTitle") }}</p>
              <p class="coupon-left-body text-base">
                {{ $t("knowhowPage.couponDescription1") }}<br />
                {{ $t("knowhowPage.couponDescription2") }}
              </p>
            </div>
          </div>
          <div class="coupon-right">
            <p class="pt-2 text-lg">{{ couponTitle }}</p>
            <p class="pt-2 text-2xl">{{ coupon.title }}</p>
            <p>{{ $t("knowhowPage.couponExpiry", { date: formatExpired }) }}</p>
          </div>
        </div>
      </div>
    </div>

    <footer>
      <img class="cat-walk" src="@/assets/img/knowhow/cat-walk.png" />
      <div class="footer-gray" />
      <div class="footer-main">
        <div class="supported">
          <span class="self-center">Supported by</span>
          <img src="@/assets/img/knowhow/filmart-logo.png" />
        </div>
        <p class="text-center">&copy; indent2022</p>
      </div>
    </footer>
  </div>
</template>

<style lang="scss" scoped>
@import "@/style-common.scss";
.header {
  z-index: 50;
  position: fixed;
  top: 0;
  width: 100vw;
  height: 50px;
  filter: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));

  @include mq(pc) {
    background-color: var(--color-background-normal);
    border: 1px solid #c7c7c7;
  }
  @include mq(sp) {
    background-color: #bac34d;
  }
}
.header-content {
  display: flex;

  @include mq(pc) {
    margin-top: 0.2rem;
    justify-content: space-between;

    & > p {
      cursor: pointer;
    }
  }
  @include mq(sp) {
    margin: 0.5rem auto 0 auto;
    color: var(--color-text-on-fixed-bg);
    justify-content: center;

    & > div {
      display: flex;
      flex-direction: column;
      justify-content: center;

      & > p {
        margin: 0;
      }
    }
  }
}
.header-content-about {
  display: flex;
  color: #2c3e50;
  cursor: pointer;

  & > img {
    margin-right: 0.5rem;
    width: 1.5rem;
    height: 1.5rem;
  }
  & > p {
    margin-top: 0.9rem;
    text-decoration-line: underline;
  }
}

.subheader {
  width: 100vw;
}

.content {
  margin-top: 50px;
  margin-bottom: 100px;
}

.appeal-text {
  position: relative;
  display: inline-block;
  padding: 0 45px;
  color: var(--color-brand-premium);

  &:before {
    left: 0;
    content: "";
    position: absolute;
    top: 85%;
    display: inline-block;
    width: 30px;
    height: 2px;
    background-color: var(--color-brand-premium);
    -webkit-transform: rotate(60deg);
    transform: rotate(60deg);
  }
  &:after {
    right: 0;
    content: "";
    position: absolute;
    top: 85%;
    display: inline-block;
    width: 30px;
    height: 2px;
    background-color: var(--color-brand-premium);
    -webkit-transform: rotate(-60deg);
    transform: rotate(-60deg);
  }
}

.appeal-button {
  padding-top: 0.75rem;
  display: flex;
  justify-content: center;

  & > button {
    padding: 0.75rem 3.5rem;
    display: flex;
    background-color: var(--color-brand-premium);
    border-radius: var(--radius-sm);
    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    border: none;
    cursor: pointer;

    & > span {
      display: flex;
      align-self: center;
      margin-top: 0.125rem;
      margin-right: 0.5rem;
      font-weight: var(--font-weight-bold);
      font-size: var(--font-size-lg);
      line-height: 1.5rem;
      color: var(--color-text-on-fixed-bg);
    }

    & > .appeal-button-logo {
      display: flex;
      align-self: center;
      height: 2rem;
      width: auto;
    }
  }
}

.outer-chapter {
  margin-top: 1.5rem;

  @include mq(pc) {
    grid-column: span 2 / span 2;
  }
  @include mq(sp) {
    grid-column: span 1 / span 1;
  }

  & > p {
    font-weight: var(--font-weight-bold);
    line-height: 1.5rem;
    margin-bottom: 0;
  }
}
.content-chapter {
  display: flex;
  border-bottom: 3px solid #eaeaea;

  & > div {
    padding-bottom: 0.75rem;
    display: flex;
    align-self: center;

    & > img {
      margin-right: 1.25rem;
      width: 2rem;
    }
  }

  & > p {
    padding-bottom: 0.5rem;
    margin: 0;
    display: flex;
    align-self: center;
    font-size: var(--font-size-lg);
    font-weight: var(--font-weight-bold);
  }
}

.knowhow-grid {
  margin-top: 1.5rem;
  display: grid;
  gap: 1.5rem;

  @include mq(pc) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    margin-left: 2rem;
    margin-right: 2rem;
  }
  @include mq(sp) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
    margin-left: 1rem;
    margin-right: 1rem;
  }
}
.knowhow-content {
  display: flex;
  background-color: var(--color-surface-muted);
  cursor: pointer;
  border-radius: var(--radius-md);
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);

  @include mq(pc) {
    padding: 0.6rem 1.25rem;
  }
  @include mq(sp) {
    padding: 0.5rem 1rem;
  }

  & > div {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    row-gap: 0.5rem;

    @include mq(sp) {
      padding: 0.5rem 0;
    }
  }

  & > img {
    margin-right: 1rem;
    display: flex;
    align-self: center;
    width: auto;
    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    background: var(--color-text-on-fixed-bg);

    @include mq(pc) {
      height: 7.5rem;
    }
    @include mq(sp) {
      height: 6rem;
    }
  }
}
.knowhow-content-title {
  margin: 0;
  padding-top: 1rem;
  font-weight: var(--font-weight-bold);
  font-family: "ヒラギノ明朝 ProN", "Hiragino Mincho ProN", "ＭＳ 明朝", "MS Mincho", sans-serif;

  @include mq(pc) {
    font-size: var(--font-size-lg);
    line-height: 1.75rem;
  }
  @include mq(sp) {
    font-size: var(--font-size-md);
    line-height: 1.5rem;
  }
}
.knowhow-content-subtitle {
  margin: 0;
  font-weight: var(--font-weight-bold);
  font-family: "ヒラギノ明朝 ProN", "Hiragino Mincho ProN", "ＭＳ 明朝", "MS Mincho", sans-serif;

  @include mq(pc) {
    font-size: var(--font-size-md);
    line-height: 1.75rem;
  }
  @include mq(sp) {
    font-size: var(--font-size-md);
    line-height: 1.5rem;
  }
}

.tag {
  color: var(--color-primary);
  font-weight: var(--font-weight-bold);
  font-family: "ヒラギノ明朝 ProN", "Hiragino Mincho ProN", "ＭＳ 明朝", "MS Mincho", sans-serif;

  @include mq(pc) {
    font-size: var(--font-size-md);
    line-height: 1.5rem;
  }
  @include mq(sp) {
    font-size: var(--font-size-sm);
    line-height: 1.25rem;
  }
}
.read-button {
  display: flex;
  justify-content: right;
  margin-top: 0.5rem;

  & > div {
    padding: 0.6rem 1rem 0.5rem 1rem;
    background-color: var(--color-brand-premium);
    border-radius: var(--radius-sm);
    color: var(--color-text-on-fixed-bg);
    font-weight: var(--font-weight-bold);
  }
}

.welcome {
  margin: 0 auto;
  font-weight: var(--font-weight-bold);
  line-height: 1.5rem;

  @include mq(pc) {
    max-width: 512px;
  }
  @include mq(sp) {
    max-width: 100%;
    padding: 2rem 3rem;
    background-color: #f2f2f2;
  }
}
@include mq(sp) {
  .welcome-body {
    margin: 0 auto;
    max-width: 512px;
  }
}

.hat-icon {
  width: 60px;
}

.coupon {
  padding: 2rem;
  border: 1px solid #707070;
  border-radius: var(--radius-sm);
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  display: grid;
  column-gap: 2rem;
  font-weight: var(--font-weight-bold);

  @include mq(pc) {
    margin: 0 auto;
    max-width: 640px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @include mq(sp) {
    margin: 0 2rem;
    max-width: none;
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}
@include mq(sp) {
  .coupon-left {
    margin: 0 auto;
  }
  .coupon-left-title {
    text-align: center;
    margin-bottom: 1.5rem;
  }
}
.coupon-left-body {
  line-height: 1.5rem;
}
.coupon-right {
  background-color: #bac34d;
  border-radius: var(--radius-sm);
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  align-self: center;
  text-align: center;
  color: var(--color-text-on-fixed-bg);
  margin: 0 auto;
  max-width: 640px;

  @include mq(pc) {
    padding: 1rem 3rem;
  }
  @include mq(sp) {
    width: 90%;
    margin-top: 1.5rem;
    padding: 1rem 1rem;
  }
}

.cat-walk {
  margin-bottom: -8px;
  width: 40px;
  position: relative;

  @include mq(pc) {
    left: 20vw;
  }
  @include mq(sp) {
    left: 5vw;
  }
}
.footer-gray {
  height: 20px;
  width: 100vw;
  background-color: #eaeaea;
}
.footer-main {
  padding-top: 1rem;
  height: 80px;
  width: 100vw;
  background-color: #bac34d;
}
.supported {
  display: flex;
  justify-content: center;

  & > span {
    margin-right: 1rem;
    font-size: var(--font-size-md);
    line-height: 1.75rem;
    font-family: "ヒラギノ明朝 ProN", "Hiragino Mincho ProN", "ＭＳ 明朝", "MS Mincho", sans-serif;
  }

  & > img {
    width: 40px;
  }
}

.notfound-view {
  margin-top: 5rem;
  height: 20vh;
  display: flex;
  justify-content: center;
  text-align: center;
}

a {
  color: #a0a0a0;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-10 {
  padding-top: 2.5rem;
}
.pt-16 {
  padding-top: 4rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.pb-10 {
  padding-bottom: 2.5rem;
}

.text-xxs {
  font-size: 0.5rem;
  line-height: 0.75rem;
}
.text-xs {
  font-size: var(--font-size-xs);
  line-height: 1rem;
}
.text-lg {
  font-size: var(--font-size-lg);
  line-height: 1.75rem;
  margin: 0;
}
.text-xl {
  font-size: var(--font-size-lg);
  line-height: 1.75rem;
  margin: 0;
}
.text-2xl {
  font-size: var(--font-size-xl);
  line-height: 2rem;
  margin: 0;
}
.font-semibold {
  font-weight: var(--font-weight-bold);
}
.text-center {
  text-align: center;
}
.text-left {
  text-align: left;
}
.text-right {
  text-align: right;
}
.self-center {
  display: flex;
  align-self: center;
}
.max-w-lg {
  max-width: 1024px;
  margin: 0 auto;
}

@include mq(pc) {
  .sp-block {
    display: none;
  }
}
@include mq(sp) {
  .pc-block {
    display: none;
  }
  .sp-block {
    display: flex;
  }
}
</style>

<script lang="ts">
import Vue from "vue";
import axiosBase from "axios";
import { Auth } from "aws-amplify";
import { format } from "date-fns";
import { Plan } from "@/lib/models/user";
import { createUrlWithUtmParams, optimizeImage } from "@/lib/utils/url";
import { NolaItemId, NolaPageName } from "@/lib/utils/analytics";

const axios = axiosBase.create({
  baseURL: process.env.VUE_APP_MICROCMS_API_ENDPOINT,
  headers: { "X-API-KEY": process.env.VUE_APP_MICROCMS_API_KEY },
});

export default Vue.extend({
  // NOTE: metaタグの設定
  metaInfo: {
    meta: [
      {
        name: "robots",
        content: "none",
      },
    ],
  },
  data() {
    return {
      contents: [],
      couponTitle: "",
      coupon: undefined,
      queryPlan: undefined,
      isNotFound: false,
      loading: true,
      previousTheme: null as string | null,
    };
  },
  mounted() {
    // ライトモード固定: 現在のテーマを保存してからライトモードに強制
    this.previousTheme = document.documentElement.getAttribute("data-app-theme");
    document.documentElement.setAttribute("data-app-theme", "light");
  },
  destroyed() {
    // 元のテーマに戻す（nullの場合はデフォルトのlightを設定）
    document.documentElement.setAttribute("data-app-theme", this.previousTheme || "light");
  },
  computed: {
    formatExpired() {
      if (this.coupon) {
        return format(this.coupon.expired, this.$t("knowhowPage.dateFormat") as string);
      }
      return "";
    },
  },
  async created() {
    this.queryPlan = this.$route.query.plan;

    // クエリパラメータに沿って認証の確認をする
    if (!this.queryPlan) {
      const user = (await Auth.currentCredentials().catch((err) => {
        if (err.code === "UserNotFoundException" || err.code === "NotAuthorizedException") {
          return;
        }
        if (err !== "No current user") {
          throw err;
        }
      })) as any;

      const isAuthenticated = user.authenticated;
      const isLogin = user && !user.code && isAuthenticated;

      // 通常は未ログインユーザーを弾く
      if (!isLogin) {
        this.$router.push("/");
      }
    }

    let couponFree;
    let couponPremium;
    try {
      const res = await axios.get("/knowhow?limit=100");
      if (res.status !== 200) {
        throw res;
      }

      res.data.contents.forEach((c) => {
        if (c.type[0] === "chapter" || c.type[0] === "content") this.contents.push(c);
        else if (c.type[0] === "coupon_free") couponFree = c;
        else if (c.type[0] === "coupon_premium") couponPremium = c;
      });
    } catch (_) {
      this.isNotFound = true;
      return;
    }

    // 会員情報の取得
    if (this.queryPlan) {
      if (this.queryPlan === "premium") {
        this.couponTitle = this.$t("knowhowPage.couponTitlePremium") as string;
        this.coupon = couponPremium;
      } else {
        this.couponTitle = this.$t("knowhowPage.couponTitleFree") as string;
        this.coupon = couponFree;
      }
    } else {
      try {
        const plan = this.$store.getters["billingModule/plan"] as Plan;
        switch (plan) {
          case Plan.monthly:
          case Plan.yearly:
          case Plan.school:
            this.couponTitle = this.$t("knowhowPage.couponTitlePremium") as string;
            this.coupon = couponPremium;
            break;
          default:
            this.couponTitle = this.$t("knowhowPage.couponTitleFree") as string;
            this.coupon = couponFree;
        }
      } catch (_) {
        this.isNotFound = true;
        return;
      }
    }

    this.loading = false;
  },
  methods: {
    toBr(text: string) {
      return text.replaceAll("\n", "<br>");
    },
    toDetail(id: string) {
      let link = `${process.env.VUE_APP_NOLANOVEL_WEB}/knowhow/${id}`;
      if (this.queryPlan) link += `?plan=${this.queryPlan}`;
      window.open(
        createUrlWithUtmParams(link, NolaPageName.KnowHow, NolaItemId.KnowHowViewDetail),
        process.env.VUE_APP_NOLANOVEL_NAME ?? ""
      );
    },
    displayedTagHtml(tag?: Array<string>) {
      if (tag) {
        const display = tag.map((value: string) => `<span class="mr-2" style="white-space: nowrap;">#${value}</span>`);
        return display.length > 0 ? display.join("\n") : this.$t("knowhowPage.tagNotSet");
      }
      return this.$t("knowhowPage.tagNotSet");
    },
    toStore() {
      window.open("https://nola0filmart.base.ec/");
    },
    optimizedImage(url: string) {
      return optimizeImage(`${url}`);
    },
  },
});
</script>
